module.exports = __webpack_public_path__ + "img/chris_g_17.4d745f35.jpg";